import { useQuery } from 'react-query';

import { useFeature } from 'src/core/common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';

import { useOrganisationId } from '../../../hooks/useOrganisationId';

const fetchHasAccessToMultiEntityConfig = async (organisationId: string) => {
  const response = await fetch(
    `${appConfig.apiUrls.apiV2}/${organisationId}/settings/access`,
    {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
  return response.json();
};

export const useHasAccessToMultiEntityConfig = ({
  isEnabled,
}: {
  isEnabled: boolean;
}):
  | { status: 'success'; hasAccess: boolean }
  | { status: 'loading' }
  | { status: 'error' } => {
  const organisationId = useOrganisationId();
  const isMultiEntityConfigFeatureEnabled = useFeature(
    FEATURES.MULTI_ENTITY_CONFIG,
  );
  const { data, isLoading, isError } = useQuery({
    queryKey: [organisationId, 'settings', 'access'],
    queryFn: () => fetchHasAccessToMultiEntityConfig(organisationId),
    enabled: isEnabled && isMultiEntityConfigFeatureEnabled,
  });

  if (isLoading) {
    return { status: 'loading' };
  }

  if (isError) {
    return { status: 'error' };
  }

  return { status: 'success', hasAccess: Boolean(data?.hasAccess) };
};
